import { useParams } from 'react-router-dom';
import { ptBR } from '@/i18n/pt-BR';
import { PlaceholderPage } from './PlaceholderPage';

export function DossiePage() {
  const { id } = useParams<{ id: string }>();
  const title = id ? `${ptBR.routes.dossie.title} · ${id}` : ptBR.routes.dossie.title;
  return <PlaceholderPage title={title} testId="dossie-page" />;
}
